import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { _URL_LOGS } from 'src/app/config/config';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor(private http: HttpClient) { }

  //get Process logs
  getProcessLogs(room): Observable<any>{  
    return this.http.get(_URL_LOGS + '/getProcessLogsByRoomId/' + room);
  }

  setProcessLog(userId, teamId, room, error, status, month): Observable<any>{
    const httpHeaders = new HttpHeaders({'Content-Type': 'application/json',});
    const json = {
      userId: userId,
      teamId: teamId,
      roomId: room,
      error: error,
      status: status,
      month: month
    };
    const params = JSON.stringify(json);
    return this.http.post(_URL_LOGS + '/setProcessLogs', params, {headers: httpHeaders,});
  }
}
